import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    buttonText: "Collaboration Proposition",
    clientLogo: null,
    homepageCollaterals: null,
    respondantPool: null,
    isOnboardingComplete: false,
    salesPoc: null,
}


export const sliceName = 'collaborationSlice'

export const collaborationSlice = createSlice({
    name: sliceName,
    initialState,
    reducers: {
        setCollaborationData: (state, action) => {
            const collaborationData = action.payload
            return collaborationData
        },
        setOnboardingState: (state, action) => {
            state.isOnboardingComplete = action.payload
        },
        setSalesPoc: (state, action) => {
            state.salesPoc = action.payload
        }
    }
})

export const selectButtonText = state => state[sliceName].buttonText
export const selectHomePageCollaterals = state => state[sliceName].homepageCollaterals

export const selectWhole = state => state[sliceName]
export const selectClientLogo = state => state[sliceName].clientLogo
export const selectJCLogo = state => state[sliceName].jcLogo
export const selectAwarded = state => state[sliceName].isAwarded
export const selectClientId = state => state[sliceName].clientId
export const selectDetailDataAudience = state => state[sliceName].audience
export const selectDetailDataCadence = state => state[sliceName].cadence
export const selectDetailDataEngagementType = state => state[sliceName].engagementType
export const selectDetailDataCountries = state => state[sliceName].country
export const selectDetailDataCostEstimation = state => state[sliceName].costEstimation
export const selectDetailDataTimelines = state => state[sliceName].timelines
export const selectSavedPropositions = state => state[sliceName].savedCollaborationProposition
export const selectDetailDataQuantitativeCost = state => state[sliceName].quantitativeCost
export const selectDetailDataQualitativeCost = state => state[sliceName].qualitativeCost
export const selectInnerPageContent = state => state[sliceName].innerPageContent
export const selectDisclaimer = state => state[sliceName].disclaimer
export const selectIsOnboardingComplete = state => state[sliceName].isOnboardingComplete
export const selectSalesPoc = state => state[sliceName].salesPoc
export const selectRespondantPoolText = state => state[sliceName].respondantPoolTitle
export const selectBG = state => state[sliceName].outerBackgroundImage?.url
export const selectInnerBG = state => state[sliceName].innerBackgroundImage?.url
export const selectCalculatedTableTitle = state => state[sliceName].calculatedTableTitle


export const selectRespondantPool = state => state[sliceName].respondantPool

export const { setCollaborationData, setOnboardingState, setSalesPoc } = collaborationSlice.actions

export default collaborationSlice.reducer